/**
 * @author       grady@zumper.com (Grady Kuhnline <gradykuhnline>)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  StaticHTMLProvider
 */

import React from 'react'
import { StaticHTMLContext } from './StaticHTMLContext'
import type { createBrowserStaticRender } from './createBrowserStaticRender'
import type { serverStaticRender } from './createServerStaticRender'

interface StaticHTMLProviderProps {
  children: React.ReactNode
  staticRender: ReturnType<typeof createBrowserStaticRender> | typeof serverStaticRender
}

const StaticHTMLProvider = ({ children, staticRender }: StaticHTMLProviderProps) => {
  return <StaticHTMLContext.Provider value={staticRender}>{children}</StaticHTMLContext.Provider>
}

export default StaticHTMLProvider
